/**
 * Verbesserungen für Barrierefreiheit bei JetEngine Swiper Slidern (ES Modul).
 * Fügt Play/Pause-Steuerelemente hinzu, verwaltet Aria-Live-Attribute und
 * synchronisiert den Status bei Interaktionen.
 */

let initJetEngineSliderAccessibility;

// Prüfen, ob jQuery verfügbar ist
if (typeof jQuery === 'undefined') {
    console.error('[Jet Slider Accessibility] jQuery wird benötigt, wurde aber nicht geladen.');
    // Stellt eine Dummy-Funktion bereit, wenn jQuery fehlt
    initJetEngineSliderAccessibility = function() {
        console.error("[Jet Slider Accessibility] Initialisierung nicht möglich - jQuery fehlt.");
    };
} else {
    (function($) {
        'use strict';

        // --- Konfiguration ---
        const triggerClass = 'slider-pause-swiper';
        const playPauseButtonClass = 'swiper-button-pause';
        const controlsWrapperClass = 'slider-controls-wrapper';
        const playingClass = 'swiper-slider-playing';
        const pausedClass = 'swiper-slider-paused';
        const swiperSelectors = [
            '.jet-listing-grid__slider.swiper',
            '.swiper-container',
            '.swiper'
        ];
        const prevArrowSelector = '.prev-arrow';
        const nextArrowSelector = '.next-arrow';

        // --- Icons & Labels ---
        const pauseIconSvg = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" fill="currentColor" width="1em" height="1em"><path d="M48 112l0 288 48 0 0-288-48 0zM0 112C0 85.5 21.5 64 48 64l48 0c26.5 0 48 21.5 48 48l0 288c0 26.5-21.5 48-48 48l-48 0c-26.5 0-48-21.5-48-48L0 112zm224 0l0 288 48 0 0-288-48 0zm-48 0c0-26.5 21.5-48 48-48l48 0c26.5 0 48 21.5 48 48l0 288c0 26.5-21.5 48-48 48l-48 0c-26.5 0-48-21.5-48-48l0-288z"/></svg>';
        const playIconSvg = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" fill="currentColor" width="1em" height="1em"><path d="M48 432L336 256 48 80l0 352zM24.5 38.1C39.7 29.6 58.2 30 73 39L361 215c14.3 8.7 23 24.2 23 41s-8.7 32.2-23 41L73 473c-14.8 9.1-33.4 9.4-48.5 .9S0 449.4 0 432L0 80C0 62.6 9.4 46.6 24.5 38.1z"/></svg>';
        const prevIconSvg = '<svg aria-hidden="true" class="e-font-icon-svg e-eicon-chevron-left" viewBox="0 0 1000 1000" xmlns="http://www.w3.org/2000/svg"><path d="M646 125C629 125 613 133 604 142L308 442C296 454 292 471 292 487 292 504 296 521 308 533L604 854C617 867 629 875 646 875 663 875 679 871 692 858 704 846 713 829 713 812 713 796 708 779 692 767L438 487 692 225C700 217 708 204 708 187 708 171 704 154 692 142 675 129 663 125 646 125Z"></path></svg>';
        const nextIconSvg = '<svg aria-hidden="true" class="e-font-icon-svg e-eicon-chevron-right" viewBox="0 0 1000 1000" xmlns="http://www.w3.org/2000/svg"><path d="M696 533C708 521 713 504 713 487 713 471 708 454 696 446L400 146C388 133 375 125 354 125 338 125 325 129 313 142 300 154 292 171 292 187 292 204 296 221 308 233L563 492 304 771C292 783 288 800 288 817 288 833 296 850 308 863 321 871 338 875 354 875 371 875 388 867 400 854L696 533Z"></path></svg>';

        const i18nGlobal = (typeof WCO_UI_Translations !== 'undefined') ? WCO_UI_Translations : {};
        const i18nSlider = i18nGlobal.slider || {};

        const pauseButtonLabelPlaying = i18nSlider.pauseLabelPlaying || 'Slider anhalten';
        const pauseButtonLabelPaused  = i18nSlider.pauseLabelPaused  || 'Slider starten';
        const targetPrevLabel         = i18nSlider.prevLabel         || 'Vorheriges Element anzeigen';
        const targetNextLabel         = i18nSlider.nextLabel         || 'Nächstes Element anzeigen';

        /**
         * Richtet Slider-Steuerelemente und Aria-Live für eine Widget-Instanz ein.
         * @param {jQuery} $scope Der Widget-Scope.
         */
        function setupSliderAccessibility($scope) {
            // Swiper-Element finden
            let $swiperElement = null;
            for (const selector of swiperSelectors) {
                $swiperElement = $scope.find(selector);
                if ($swiperElement.length) { break; }
            }
            if (!$swiperElement || !$swiperElement.length) { return; }

            /**
             * Initialisierungslogik, sobald die Swiper-Instanz verfügbar ist.
             */
            function initialize() {
                const swiperInstance = $swiperElement[0].swiper;

                // Auf Swiper-Initialisierung warten
                if (!swiperInstance) {
                    let retries = $scope.data('a11y-retries') || 0;
                    if (retries < 20) {
                        $scope.data('a11y-retries', retries + 1);
                        setTimeout(initialize, 300);
                    }
                    return;
                }

                // Autoplay-Verhalten anpassen
                // Verhindert, dass Swiper das Autoplay bei Interaktion (Klick auf Pfeile) dauerhaft deaktiviert
                if (swiperInstance.params.autoplay) {
                    swiperInstance.params.autoplay.disableOnInteraction = false;
                    // Neustart erforderlich, damit Parameteränderung übernommen wird
                    if (swiperInstance.autoplay.running) {
                        swiperInstance.autoplay.stop();
                        swiperInstance.autoplay.start();
                    }
                }

                // Navigations-Buttons optimieren (Labels & Tabindex)
                const $arrows = $scope.find(`${prevArrowSelector}, ${nextArrowSelector}`);
                $arrows.each(function() {
                    const $btn = $(this);
                    const isPrev = $btn.is(prevArrowSelector);

                    $btn.html(isPrev ? prevIconSvg : nextIconSvg);

                    $btn.attr({
                        'role': 'button',
                        'tabindex': '0',
                        'aria-label': isPrev ? targetPrevLabel : targetNextLabel
                    });

                    // Aria-Live bei Klick kurzzeitig aktivieren
                    $btn.off('click.a11yLive').on('click.a11yLive', () => {
                        $swiperElement.attr('aria-live', 'polite');
                    });

                    // Tastatursteuerung für Navigations-Pfeile
                    $btn.off('keydown.a11y').on('keydown.a11y', (e) => {
                        if (e.key === 'Enter' || e.key === ' ') {
                            e.preventDefault();
                            $btn.trigger('click');
                        }
                    });
                });

                // Play/Pause Logik nur ausführen, wenn Trigger-Klasse vorhanden
                if (!$scope.hasClass(triggerClass)) { return; }

                // Verhindern, dass Steuerelemente mehrfach hinzugefügt werden
                if ($scope.find(`.${playPauseButtonClass}`).length > 0) { return; }

                // Play/Pause-Button erstellen
                const $button = $('<button></button>')
                    .addClass(playPauseButtonClass)
                    .attr({'type': 'button'});

                /**
                 * Aktualisiert das visuelle Erscheinungsbild und die Aria-Attribute des Buttons.
                 * @param {boolean} running Gibt an, ob der Slider aktuell läuft.
                 */
                function updateButtonUI(running) {
                    if (running) {
                        $button.removeClass(pausedClass).addClass(playingClass)
                            .attr({'aria-label': pauseButtonLabelPlaying, 'aria-pressed': 'false'})
                            .html(pauseIconSvg);
                        $swiperElement.attr('aria-live', 'off');
                    } else {
                        $button.removeClass(playingClass).addClass(pausedClass)
                            .attr({'aria-label': pauseButtonLabelPaused, 'aria-pressed': 'true'})
                            .html(playIconSvg);
                        $swiperElement.attr('aria-live', 'polite');
                    }
                }

                // Initialen Wiedergabestatus setzen
                updateButtonUI(swiperInstance.autoplay && swiperInstance.autoplay.running);

                // Synchronisierung über Swiper-Events
                // Stellt sicher, dass das UI auch reagiert, wenn Swiper intern pausiert
                swiperInstance.on('autoplayStop', () => updateButtonUI(false));
                swiperInstance.on('autoplayStart', () => updateButtonUI(true));

                // Klick-Handler für Play/Pause-Steuerung
                $button.on('click', function() {
                    if (swiperInstance.autoplay.running) {
                        swiperInstance.autoplay.stop();
                    } else {
                        swiperInstance.autoplay.start();
                    }
                });

                // Steuerelemente-Wrapper erstellen und in das UI einfügen
                const $controlsWrapper = $('<div></div>').addClass(controlsWrapperClass);
                const $prev = $scope.find(prevArrowSelector).first();
                const $next = $scope.find(nextArrowSelector).first();

                if ($prev.length) {
                    // Integration in bestehende Pfeil-Struktur für korrekten Tab-Flow
                    $prev.before($controlsWrapper);
                    $controlsWrapper.append($prev).append($button).append($next);
                } else {
                    // Fallback, falls keine Pfeile vorhanden sind
                    $swiperElement.after($controlsWrapper.append($button));
                }
            }

            initialize();
        }

        /**
         * Definiert die exportierte Initialisierungsfunktion. Registriert Elementor-Hooks.
         */
        initJetEngineSliderAccessibility = function() {
            $(window).off('elementor/frontend/init.jetSliderAccessibility')
                .on('elementor/frontend/init.jetSliderAccessibility', function () {
                    const hookNameDefault = 'frontend/element_ready/jet-listing-grid.default';
                    elementorFrontend.hooks.addAction(hookNameDefault, setupSliderAccessibility);
                });
        };

    }(jQuery));
}

export { initJetEngineSliderAccessibility };